import { Timestamp } from '@bufbuild/protobuf';
import styled from '@emotion/styled';
import {
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { formatSecondsToDateTimeString } from 'libs/shared-ui/src/commonUtils/utilFunctions';
import PersonIcon from '@mui/icons-material/Person';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'black',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    borderRadius: '8px',
    fontSize: pxToRem(6), // Adjust tooltip font size if needed
  },
}));

interface IQuestionDetails {
  teacherName: string;
  createdOn: Timestamp;
}
export const TeacherUploadedTag = (props: IQuestionDetails) => {
  const { teacherName, createdOn } = props;
  return (
    <BootstrapTooltip
      sx={{
        display: 'flex',
      }}
      title={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(8),
            padding: {
              xs: pxToRem(10),
              md: pxTovW(20),
            },
            border: '2px solid #FFFFFF',
            margin: pxToRem(10),
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: '#FFFFFF',
              lineHeight: '27px',
              fontFamily: 'Poppins',
            }}
          >
            Teacher Name: <span style={{ fontWeight: 700 }}>{teacherName}</span>
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: '#FFFFFF',
              lineHeight: '27px',
              fontFamily: 'Poppins',
            }}
          >
            Uploaded on:{' '}
            <span style={{ fontWeight: 700 }}>
              {formatSecondsToDateTimeString(createdOn.seconds)}
            </span>
          </Typography>
        </Box>
      }
      arrow
      placement="top"
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: pxToRem(8),
          px: pxToRem(12),
          py: pxToRem(6),
          backgroundColor: '#FFF3CD',
          border: '1px solid #FFE69C',
          borderRadius: pxToRem(20),
          width: 'fit-content',
          cursor: 'pointer',
        }}
      >
        <PersonIcon
          sx={{
            fontSize: pxToRem(16),
            color: '#6C757D',
          }}
        />
        <Typography
          sx={{
            fontSize: pxToRem(12),
            fontWeight: 600,
            color: '#856404',
          }}
        >
          Teacher Uploaded
        </Typography>
      </Box>
    </BootstrapTooltip>
  );
};
